var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DatePicker',{staticClass:"resetable",attrs:{"type":"daterange","placeholder":_vm.placeholder,"editable":_vm.editable,"clearable":true},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})}
var staticRenderFns = []

export { render, staticRenderFns }